import { render, staticRenderFns } from "./BookingPosition.vue?vue&type=template&id=390984fa&scoped=true&"
import script from "./BookingPosition.vue?vue&type=script&lang=js&"
export * from "./BookingPosition.vue?vue&type=script&lang=js&"
import style0 from "./BookingPosition.vue?vue&type=style&index=0&id=390984fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390984fa",
  null
  
)

export default component.exports